<script setup>
import { computed, ref, toValue, useAttrs } from "vue";
import TheInput from "./TheInput.vue";
import TheButton from "./TheButton.vue";
import { useVacancies } from "@/stores/vacancies.js";

const value = ref("");
const attr = useAttrs();
const store = useVacancies();

function handleSubmit() {
  return store.applyFilter("_search", toValue(value));
}
</script>

<template>
  <form :class="$style.wrapper" @submit.prevent="handleSubmit" v-bind="attr">
    <fieldset :class="$style.group" role="group">
      <TheInput
        type="search"
        placeholder="Профессия или должность"
        autocomplete="off"
        v-model="value"
        :class="$style.input"
        :options="store.keywordOptions"
        @select="handleSubmit"
      />
      <TheButton :class="$style.button" type="submit">Найти</TheButton>
    </fieldset>
  </form>
</template>

<style module>
.wrapper {
  display: block;
  padding: 22px 33px;
  width: 100%;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 8px 24px 0 #51576514;
  z-index: 1;
}

.group {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  column-gap: 16px;
  width: 100%;
  margin: 0;
  padding: 0;
  border: none;
}

.input {
  flex-grow: 1;
  flex-shrink: 0;
}

.button {
  flex-grow: 0;
  flex-shrink: 1;
}

@media screen and (max-width: 480px) {
  .wrapper {
    background-color: transparent;
    padding: 0;
    box-shadow: none;
  }

  .group {
    flex-direction: column;
    row-gap: 10px;
  }

  .input {
    --offset: calc((100vw - var(--container-width)) / 2 - 1px);
    margin: 0 calc(var(--offset) * -1);
    box-shadow: 0 8px 24px 0 #51576514;
  }

  .input [type="search"] {
    padding-left: calc(var(--offset) + 16px * 2);
    padding-right: var(--offset);
    height: 58px;
    line-height: 58px;
    border-color: transparent;
    border-radius: 0;
    box-shadow: none;
    background-size: 16px;
    background-repeat: no-repeat;
    background-position: left var(--offset) center;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI4XzM3NSkiPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDFfMjhfMzc1KSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIuNSA2Ljk5MjE5QzEyLjUgOS43NTM2MSAxMC4yNjE0IDExLjk5MjIgNy41IDExLjk5MjJDNC43Mzg1OCAxMS45OTIyIDIuNSA5Ljc1MzYxIDIuNSA2Ljk5MjE5QzIuNSA0LjIzMDc3IDQuNzM4NTggMS45OTIxOSA3LjUgMS45OTIxOUMxMC4yNjE0IDEuOTkyMTkgMTIuNSA0LjIzMDc3IDEyLjUgNi45OTIxOVpNMTEuNzAwMSAxMi41OTI2QzEwLjUzMDIgMTMuNDcxNCA5LjA3NTkxIDEzLjk5MjIgNy41IDEzLjk5MjJDMy42MzQwMSAxMy45OTIyIDAuNSAxMC44NTgyIDAuNSA2Ljk5MjE5QzAuNSAzLjEyNjIgMy42MzQwMSAtMC4wMDc4MTI1IDcuNSAtMC4wMDc4MTI1QzExLjM2NiAtMC4wMDc4MTI1IDE0LjUgMy4xMjYyIDE0LjUgNi45OTIxOUMxNC41IDguNTY4MSAxMy45NzkyIDEwLjAyMjQgMTMuMTAwNCAxMS4xOTIzQzEzLjEzNzYgMTEuMjIwMyAxMy4xNzMzIDExLjI1MTIgMTMuMjA3MSAxMS4yODUxTDE2LjIwNzEgMTQuMjg1MUMxNi41OTc2IDE0LjY3NTYgMTYuNTk3NiAxNS4zMDg4IDE2LjIwNzEgMTUuNjk5M0MxNS44MTY2IDE2LjA4OTggMTUuMTgzNCAxNi4wODk4IDE0Ljc5MjkgMTUuNjk5M0wxMS43OTI5IDEyLjY5OTNDMTEuNzU5IDEyLjY2NTUgMTEuNzI4MSAxMi42Mjk4IDExLjcwMDEgMTIuNTkyNloiIGZpbGw9IiM5MTlBQTQiLz4KPC9nPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI4XzM3NSI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNSAtMC4wMDc4MTI1KSIvPgo8L2NsaXBQYXRoPgo8Y2xpcFBhdGggaWQ9ImNsaXAxXzI4XzM3NSI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNSAtMC4wMDc4MTI1KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=");
  }
}

@media screen and (max-width: 320px) {
  .input {
    --offset: 0px;
  }
}
</style>
